import React from 'react';
import PageDialogOverlay from 'components/PageDialogOverlay';
import whatsNewPageContent from './constants';
import './WhatsNewPage.scss';

function WhatsNewPage() {
  return (
    <PageDialogOverlay
      parentClassName="whatsnew"
      headerTitle="What's New"
      pageTitle="What's New"
      backButtonText="Support"
      backLocation="/support"
    >
      {whatsNewPageContent.map(item => {
        return (
          <div className="whatsnew-feature-lists" key={item.key}>
            <div className="feature-list">
              <img src={item.contentImg} alt="" />
            </div>
            <div className="feature-list">
              <h2>{item.header}</h2>
              <p>{item.content}</p>
            </div>
          </div>
        );
      })}
    </PageDialogOverlay>
  );
}

export default WhatsNewPage;
